import styled from "styled-components";
import {
  InputCheckbox as InputCheckboxBUI,
  CardContent,
} from "discover.medical.react-component-library";

export const InputCheckbox = styled(InputCheckboxBUI)`
  display: block;
  font-size: 0.875rem;
  margin: 0.25rem;
`;

export const ColumnLayout = styled(CardContent)`
  column-count: 1;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    column-count: 2;
  }
`;
